"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var styles = require("./InfiniteLoaderDesktop.scss");
var Loader_1 = require("./../../Loader");
var InfiniteLoader = /** @class */ (function (_super) {
    __extends(InfiniteLoader, _super);
    function InfiniteLoader() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    InfiniteLoader.prototype.render = function () {
        var props = {
            data: {
                styles: __assign({}, styles),
                text: this.props.text,
                customLoader: this.props.customLoader,
            },
            testId: this.props.testId,
        };
        return Loader_1.default(props);
    };
    return InfiniteLoader;
}(React.Component));
exports.default = InfiniteLoader;
//# sourceMappingURL=InfiniteLoaderDesktop.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/login-ui/components/common/InfiniteLoader/InfiniteLoaderDesktop/InfiniteLoaderDesktop.js
// module id = 1708
// module chunks = 8